<template>
  <div class="main-chart-pie">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="Tractores"
        name="first">
        <el-row :gutter="20">
          <el-col
            :span="19"
            style="height: 430px;max-height: 430px;">
            <title-chart
              :year="year"
              :labels="labels"
              :data="chartTractor"/>
          </el-col>
          <el-col
            :span="5"
            style="height: 432px;max-height: 432px;">
            <card-objective
              :total="totalTractores"
              :done="doneTotalTractores"
              title="Tractores"/>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane
        label="Equipo Forrajero & EE"
        name="second">
        <el-row :gutter="20">
          <el-col
            :span="19"
            style="height: 430px;max-height: 430px;">
            <title-chart
              :year="year"
              :labels="labels"
              :data="chartForrajero"/>
          </el-col>
          <el-col
            :span="5"
            style="height: 432px;max-height: 432px;">
            <card-objective
              :total="totalForrajero"
              :done="doneTotalForrajero"
              title="Equipo Forrajero & EE"/>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane
        label="Implementos"
        name="third">
        <el-row :gutter="20">
          <el-col
            :span="19"
            style="height: 430px;max-height: 430px;">
            <title-chart
              :year="year"
              :labels="labels"
              :data="chartImplemento"/>
          </el-col>
          <el-col
            :span="5"
            style="height: 432px;max-height: 432px;">
            <card-objective
              :total="totalImplementos"
              :done="doneTotalImplementos"
              title="Implementos"/>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import http from '@/services/http.service'
import TitleChart from '@/modules/dashboard/title-chart'
import CardObjective from '@/modules/dashboard/card-objective'
import moment from 'moment'
export default {
  name: 'DashboardChartAdmin',
  components: {
    TitleChart,
    CardObjective
  },
  props: {
    year: {
      type: String,
      default: moment().format('YYYY')
    }
  },
  data () {
    return {
      labels: ['Completadas', 'Faltantes', 'Sin existencia'],
      totalTractores: 0,
      doneTotalTractores: 0,
      totalForrajero: 0,
      doneTotalForrajero: 0,
      totalImplementos: 0,
      doneTotalImplementos: 0,
      chartTractor: [],
      chartForrajero: [],
      chartImplemento: [],
      activeName: 'first'
    }
  },
  computed: {
    datesRange () {
      return [
        {
          label: 'Primer trimestre',
          value: [`${this.year}-01-01`, `${this.year}-03-31`]
        },
        {
          label: 'Segundo trimestre',
          value: [`${this.year}-04-01`, `${this.year}-06-30`]
        },
        {
          label: 'Tercer trimestre',
          value: [`${this.year}-07-01`, `${this.year}-09-30`]
        },
        {
          label: 'Cuarto trimiestre',
          value: [`${this.year}-10-01`, `${this.year}-12-31`]
        }
      ]
    }
  },
  watch: {
    year: function (newYear, oldYear) {
      this.calculateCards(`${this.year}-01-01`, `${this.year}-12-31`)
      this.totalEquipment()
    }
  },
  mounted () {
    this.calculateCards(`${this.year}-01-01`, `${this.year}-12-31`)
    this.totalEquipment()
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    calculateCards (dateStart, dateEnd) {
      let promises = []
      promises.push(http.get(`dashboard/goals?startDate=${dateStart}&endDate=${dateEnd}`))
      promises.push(http.get(`dashboard/met-goals?startDate=${dateStart}&endDate=${dateEnd}`))
      Promise.all(promises)
        .then(data => {
          this.totalTractores = data[0].data.tractores
          this.totalForrajero = data[0].data.forrajero
          this.totalImplementos = data[0].data.implemento
          this.doneTotalTractores = data[1].data.tractores
          this.doneTotalForrajero = data[1].data.forrajero
          this.doneTotalImplementos = data[1].data.implemento
        })
        .catch(e => {
          this.$message.error('Peticiones rechazadas.')
        })
    },
    totalEquipment () {
      this.chartTractor = []
      this.chartForrajero = []
      this.chartImplemento = []
      for (let date of this.datesRange) {
        let totalEquipment = 0
        let totalForrajero = 0
        let totalImplemento = 0
        let doneTotalEquipment = 0
        let doneTotalForrajero = 0
        let doneTotalImplemento = 0
        let dataChartEquipment = []
        let dataChartForrajero = []
        let dataChartImplemento = []
        let promises = []
        promises.push(http.get(`dashboard/goals?startDate=${date.value[0]}&endDate=${date.value[1]}`))
        promises.push(http.get(`dashboard/met-goals?startDate=${date.value[0]}&endDate=${date.value[1]}`))
        Promise.all(promises)
          .then(data => {
            totalEquipment = data[0].data.tractores
            totalForrajero = data[0].data.forrajero
            totalImplemento = data[0].data.implemento
            doneTotalEquipment = data[1].data.tractores
            doneTotalForrajero = data[1].data.forrajero
            doneTotalImplemento = data[1].data.implemento
            /// ///////////calulate value of chart////////////////////////////
            dataChartEquipment = totalEquipment === 0 ? [totalEquipment, doneTotalEquipment, 100]
              : [doneTotalEquipment, (totalEquipment - doneTotalEquipment)]

            dataChartForrajero = totalForrajero === 0 ? [totalForrajero, doneTotalForrajero, 100]
              : [doneTotalForrajero, (totalForrajero - doneTotalForrajero)]

            dataChartImplemento = totalImplemento === 0 ? [totalImplemento, doneTotalImplemento, 100]
              : [doneTotalImplemento, (totalImplemento - doneTotalImplemento)]

            this.chartTractor.push([{
              data: dataChartEquipment,
              backgroundColor: ['#FF8206', '#FF231E', '#B4B9B9']
            }])
            this.chartForrajero.push([{
              data: dataChartForrajero,
              backgroundColor: ['#FF8206', '#FF231E', '#B4B9B9']
            }])
            this.chartImplemento.push([{
              data: dataChartImplemento,
              backgroundColor: ['#FF8206', '#FF231E', '#B4B9B9']
            }])
          })
          .catch(e => {
            this.$message.error('Peticiones rechazadas.')
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main-chart-pie{
    margin-top: 30px;
    border-radius: 3px;
    background-color: #FFF;
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/dashboard-chart-admin.vue